"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _StyleSheet = _interopRequireDefault(require("react-native-web/dist/cjs/exports/StyleSheet"));
var _Text = _interopRequireDefault(require("react-native-web/dist/cjs/exports/Text"));
var _View = _interopRequireDefault(require("react-native-web/dist/cjs/exports/View"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _ThemeProvider = require("../ThemeProvider");
var _utils = require("../utils");
var _LabelContent = _interopRequireDefault(require("./LabelContent"));
var _Tooltip = _interopRequireDefault(require("../Tooltip"));
var _shared = _interopRequireDefault(require("../Tooltip/shared"));
var _jsxRuntime = require("react/jsx-runtime");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
const [selectProps, selectedSystemPropTypes] = (0, _utils.selectSystemProps)([_utils.a11yProps, _utils.viewProps]);
const selectLabelStyles = (tokens, themeOptions) => (0, _ThemeProvider.applyTextStyles)({
  ...(0, _utils.selectTokens)('Typography', tokens),
  themeOptions
});
const selectHintStyles = (_ref, themeOptions) => {
  let {
    hintColor,
    hintFontName,
    hintFontSize,
    hintFontWeight,
    hintLineHeight
  } = _ref;
  return (0, _ThemeProvider.applyTextStyles)({
    color: hintColor,
    fontName: hintFontName,
    fontSize: hintFontSize,
    fontWeight: hintFontWeight,
    lineHeight: hintLineHeight,
    themeOptions
  });
};
const selectGapStyles = _ref2 => {
  let {
    gap
  } = _ref2;
  return {
    marginRight: gap
  };
};
const InputLabel = /*#__PURE__*/_react.default.forwardRef((_ref3, ref) => {
  let {
    copy = 'en',
    label,
    forId,
    hint,
    hintPosition = 'inline',
    hintId,
    tooltip,
    tokens,
    variant,
    characterCount,
    maxCharacterAllowed,
    ...rest
  } = _ref3;
  const themeTokens = (0, _ThemeProvider.useThemeTokens)('InputLabel', tokens, variant);
  const hasTooltip = tooltip !== undefined;
  const isHintInline = hintPosition === 'inline';
  const {
    themeOptions
  } = (0, _ThemeProvider.useTheme)();
  const getTooltipProps = () => {
    return typeof tooltip === 'string' ? {
      content: tooltip
    } : tooltip;
  };
  return /*#__PURE__*/(0, _jsxRuntime.jsxs)(_jsxRuntime.Fragment, {
    children: [/*#__PURE__*/(0, _jsxRuntime.jsxs)(_View.default, {
      ref: ref,
      style: staticStyles.container,
      ...selectProps(rest),
      children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(_Text.default, {
        style: [selectLabelStyles(themeTokens, themeOptions), selectGapStyles(themeTokens), staticStyles.label],
        children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_LabelContent.default, {
          forId: forId,
          children: label
        })
      }), hint && isHintInline && /*#__PURE__*/(0, _jsxRuntime.jsx)(_Text.default, {
        style: [selectHintStyles(themeTokens, themeOptions), hasTooltip && selectGapStyles(themeTokens), staticStyles.label],
        nativeID: hintId,
        children: hint
      }), hasTooltip && /*#__PURE__*/(0, _jsxRuntime.jsx)(_View.default, {
        style: [staticStyles.tooltipAlign, {
          height: themeTokens.fontSize * themeTokens.lineHeight,
          color: themeTokens.color
        }],
        children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_Tooltip.default, {
          copy: copy,
          ...getTooltipProps()
        })
      }), maxCharacterAllowed && isHintInline && /*#__PURE__*/(0, _jsxRuntime.jsxs)(_Text.default, {
        style: [selectHintStyles({
          ...themeTokens
        }), staticStyles.characterCountlabel],
        children: [characterCount, "/", maxCharacterAllowed]
      })]
    }), hint && !maxCharacterAllowed && !isHintInline && /*#__PURE__*/(0, _jsxRuntime.jsx)(_Text.default, {
      style: [selectHintStyles(themeTokens), staticStyles.hintBelow],
      nativeID: hintId,
      children: hint
    }), hint && maxCharacterAllowed && !isHintInline && /*#__PURE__*/(0, _jsxRuntime.jsxs)(_View.default, {
      style: staticStyles.container,
      children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(_Text.default, {
        style: [selectHintStyles(themeTokens), staticStyles.flexHintBelow],
        nativeID: hintId,
        children: hint
      }), /*#__PURE__*/(0, _jsxRuntime.jsxs)(_Text.default, {
        style: [selectHintStyles(themeTokens), staticStyles.characterCountlabel],
        children: [characterCount, "/", maxCharacterAllowed]
      })]
    })]
  });
});
InputLabel.displayName = 'InputLabel';
InputLabel.propTypes = {
  ...selectedSystemPropTypes,
  /**
   * Whether the English or French copy will be used (e.g. for accessibility labels).
   */
  copy: _propTypes.default.oneOf(['en', 'fr']),
  /**
   * The input label.
   */
  label: _propTypes.default.string.isRequired,
  /**
   * The id attribute of the input which this label refers to.
   */
  forId: _propTypes.default.string,
  /**
   * A short description of the expected input.
   */
  hint: _propTypes.default.string,
  /**
   * Position of the hint relative to label. Use `below` to display a larger hint below the label.
   */
  hintPosition: _propTypes.default.oneOf(['inline', 'below']),
  /**
   * The id attribute passed down to the hint element.
   */
  hintId: _propTypes.default.string,
  /**
   * Content of an optional `Tooltip`. If set, a tooltip button will be shown next to the label.
   */
  tooltip: _propTypes.default.oneOfType([_shared.default, _propTypes.default.string]),
  /**
   * Current number of characterts of an input text.
   */
  characterCount: _propTypes.default.number,
  /**
   * Max number of characters that allows an input text.
   */
  maxCharacterAllowed: _propTypes.default.number,
  tokens: (0, _utils.getTokensPropType)('InputLabel'),
  variant: _utils.variantProp.propType
};
var _default = exports.default = InputLabel;
const staticStyles = _StyleSheet.default.create({
  container: {
    flexShrink: 1,
    flexDirection: 'row'
  },
  characterCountlabel: {
    marginLeft: 'auto',
    marginTop: 'auto'
  },
  label: {
    flexShrink: 1,
    alignSelf: 'center'
  },
  hintBelow: {
    flexBasis: '100%',
    flexShrink: 0
  },
  flexHintBelow: {
    flexBasis: '100%',
    flexShrink: 1
  },
  tooltipAlign: {
    alignSelf: 'center',
    justifyContent: 'center'
  }
});